module.exports = __webpack_public_path__ + "img/chinesecompany16.edc94aee.png";